import VerifiedIcon from 'components/icons/VerifiedIcon';
import React from 'react';

const CSS = require('./SuccessMessage.module.scss');

function SuccessMessage() {
  return (
    <div className={CSS.Container}>
      <div className={CSS.SuccessMessage}>
        <VerifiedIcon width={16} height={16} className={CSS.Icon} />
        <span className={CSS.Text}>Your changes have been saved!</span>
      </div>
    </div>
  );
}

export default SuccessMessage;
